import { FC, useContext, useEffect } from 'react';
import { AuthContext, Form } from '@repo-level/core-front';

import { FormGroup } from 'components/form/groups/FormGroup';
import { Select } from 'components/form/Select';
import { required } from 'helpers/validators';
import { OfUnion } from 'types/common';
import { ScFieldExpiryDateRow } from './styled';
import { useFieldState } from 'informed';
import { Checkbox } from 'components/form/Checkbox';
import { useTranslation } from 'react-i18next';
import { CommonUtilsContext } from 'contexts/commonUtils';

const METHOD_TOKENIZE = 'methodFieldsData.tokenize';
const AMOUNT = 'amountValue';

export const FieldSelect: FC<
  OfUnion<Form.MethodField>[Form.MethodFieldType.Select]
> = ({ fieldName, placeholder, label, options }) => {
  const fieldState = useFieldState(fieldName);
  const { setCurrentAmount } = useContext(AuthContext);
  const { t } = useTranslation('deposits');
  const { isMobileS } = useContext(CommonUtilsContext);

  const amount = fieldName.includes(AMOUNT);

  useEffect(() => {
    if (!amount) return;

    if (!fieldState?.value) {
      setCurrentAmount('');
    } else {
      setCurrentAmount(Number(fieldState.value));
    }
  }, [fieldState?.value, amount, setCurrentAmount]);

  if (fieldName.includes(METHOD_TOKENIZE)) {
    return (
      <FormGroup marginTop={isMobileS ? 12 : 16}>
        <Checkbox
          label={t('deposits:savePayment')}
          field={fieldName}
          parse={(val) => (val ? 'true' : 'false')}
          format={(val) => val === 'true'}
        />
      </FormGroup>
    );
  }

  const optionsFormatted = options.map(({ label, value }) => ({
    name: label,
    value,
  }));

  return (
    <FormGroup title={label || undefined}>
      <ScFieldExpiryDateRow $list>
        <Select
          field={fieldName}
          placeholder={placeholder || label || fieldName}
          options={optionsFormatted}
          validate={required}
          validateOnBlur
        />
      </ScFieldExpiryDateRow>
    </FormGroup>
  );
};
